import styled from "styled-components";

import CheckboxPrimitive from "ds/Checkbox";

const tagHeight = "24px";
const tagGap = "8px";

export const Checkbox = styled(CheckboxPrimitive)`
  margin-bottom: 16px;
`;

export const TeamList = styled.div`
  max-height: calc((${tagHeight} + ${tagGap}) * 3);
  overflow: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${tagGap};
  padding: 8px;
  margin: -8px;
`;

export const OverflowListActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 24px;
`;
